import { externalMobileDashboardRoutes } from './external-mobile-dashboard.routing'
import { ExternalMobileDashboardComponent } from './external-mobile-dashboard.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'

@NgModule({
  declarations: [ExternalMobileDashboardComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(externalMobileDashboardRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
  ],
  exports: [ExternalMobileDashboardComponent],
})
export class ExternalMobileDashboardModule {}
